import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CHEMISTORDERDETAILS_INIT_ACTION,
  FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTORDERDETAILS_FAIL_ACTION,
  FETCH_CHEMISTORDERVIEW_INIT_ACTION,
  FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
  FETCH_CHEMISTORDERVIEW_FAIL_ACTION
} from "./action";

import { appConfig } from "../../config";
import "react-toastify/dist/ReactToastify.css";

function* fetchChemistOrders(value) {
  const token = localStorage.getItem("token");
  let pageno = ((!value.value) ? 1 :(value.value.page === undefined ? 1 : value.value.page));
  let searchquery = ((!value.value) ? "" :(value.value.searchquery=== "" ? "":value.value.searchquery));
  let status=((!value.value) ? "" :(value.value.filter ==="" ? "":value.value.filter));

  try {
    const res = yield fetch(
      `${appConfig.ip}/purchaseOrder?orderType=purchase&orgType=chemist&status=${status}&search=${searchquery}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTORDERDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTORDERDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchchemistorderview(value) {
  console.log(value);
  let pageno = ((!value.value) ? 1 :(value.value.page === undefined ? 1 : value.value.page));
  let id =  value.value.item.item.id&&value.value.item.item.id; 

  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/orderDetails?orderId=${id}&limit=5&page=${pageno}` ,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTORDERVIEW_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTORDERVIEW_FAIL_ACTION, error: err });
    } else {
    }
  }
}

export function* ChemistOrderActionWatcher() {
  yield takeEvery(FETCH_CHEMISTORDERDETAILS_INIT_ACTION, fetchChemistOrders);
  yield takeEvery(FETCH_CHEMISTORDERVIEW_INIT_ACTION, fetchchemistorderview);
}
